import { Globals } from "../CoreApp/Globals.js";
import { ReportTiming } from "./ReportTiming.js";

export function RemoveMsgCanvas() {
  ReportTiming("Done");

  var msgCanvas = document.getElementById("msgcanvas");
  if (msgCanvas == null) return;
  if (msgCanvas.fLoadingElement) Globals._timerMgr.ClearTimer();
  document.body.removeChild(msgCanvas);
}
